module.exports = __webpack_public_path__ + "img/fileType.3ed9a834.png";